import { Eye, Target } from "lucide-react";
import "./index.css";

export default function VisionMission() {
  return (
    <div className="vision-mission-container">
      <main className="main-content">
        <h1 className="page-title">Our Vision and Mission</h1>

        <p className="page-description">
          At the core of our company lies a strong vision and mission that guide
          our every action and decision.
        </p>

        <div className="vision-mission-grid">
          <div className="vision-card">
            <div className="card-icon">
              <Eye size={48} />
            </div>
            <h2>Our Vision</h2>
            <p>
              To establish ourselves as one of the foremost and most trusted
              brokerage firms, catering to retail, institutional, and
              international investors seeking to invest in Pakistan’s stock
              markets. We are committed to providing seamless, transparent, and
              technology-driven trading solutions that empower our clients with
              expert insights, efficient execution, and a secure investment
              environment. Through innovation, integrity, and excellence in
              financial services, we aim to foster long-term relationships and
              contribute to the growth and development of Pakistan’s capital
              market
            </p>
          </div>

          <div className="mission-card">
            <div className="card-icon">
              <Target size={48} />
            </div>
            <h2>Our Mission</h2>
            <p>
              To provide attractive low cost brokerage services to our valued
              clients, provide our clients with state of the art trading
              facilities and up-to-date capital market research and offer them
              best execution of their investment plan. Our professional
              trainings team will educate our clients about the investment
              instruments and how to discover new horizons of investments to
              place their fortune. Our financial advisors will offer step by
              step guidance to our valued clients to achieve their goals and our
              compliance and settlement team will keep track of the investments
              to make sure that every aspect of the investments meets the
              regulatory requirement of the capital markets.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
